module.exports = __webpack_public_path__ + "img/program2-s.a27e12d9.png";